import classNames from 'classnames'
import { type FC } from 'react'
import { Icon, type IIconsVector, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IWidgetPositionOptionProps = {
  icon: IIconsVector
  label: string
  isSelected: boolean
  onClick: () => void
  ariaLabel: string
}

export const WidgetPositionOption: FC<IWidgetPositionOptionProps> = ({
  icon,
  label,
  isSelected,
  onClick,
  ariaLabel,
}) => (
  <button
    type='button'
    className={classNames(styles.option, { [styles.selected]: isSelected })}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <Icon
      icon={icon}
      fontSize={20}
      color={isSelected ? 'var(--content-brand-primary)' : 'var(--content-primary-tertiary)'}
    />
    <Typography
      variant='body-md-regular'
      ariaLabel={`${ariaLabel} text`}
      color={'var(--content-primary-primary)'}
    >
      {label}
    </Typography>
  </button>
)
